"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAttach = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const element_1 = require("../element");
const featureFlags_1 = require("../featureFlags");
const ImageTag_1 = __importDefault(require("./ImageTag"));
const AttachFileRegistStyled = styled_components_1.default.div `
	width: 100%;

	.field-global-001 {
		${props => props.$forceTitle &&
    `padding: 20px 0;
    border-style: solid;
    border-color: var(--color-grey-c, #e6e8ed);
    border-width: 0.5px 0px 0px 0px;`}
	}

	.file-container {
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;

		.file-wrap {
			background: var(--color-white, #ffffff);
			border-radius: 4px;
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: ${props => (props.$isOnlyFile ? '0px' : '1px')};
			display: flex;
			flex-direction: ${props => (props.$isOnlyFile ? 'column' : 'row')};
			gap: ${props => (props.$isOnlyFile ? '20px' : '10px')};
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			overflow: auto;
			width: 100%;
		}

		.file-item-wrap {
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: ${props => (props.$isMobile ? 'flex-start' : 'center')};
			justify-content: flex-start;
			flex: 1;
			position: relative;
			overflow: auto;
			width: 100%;
			flex-wrap: wrap;
			padding: ${props => props.$isOnlyFile ? '0px' : props.$isMobile ? '6px 10px' : '10px'};

			${props => props.$isOnlyFile &&
    !props.$forceTitle &&
    `border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 0.5px 0px 0px 0px;
			padding-top: 20px;`}

			${props => props.$isMobile
    ? (0, styled_components_1.css) `
							button {
								padding: 2px 4px;
								svg {
									min-width: 12px;
									min-height: 12px;
								}
								p {
									font-size: 10px;
									min-width: unset;
								}
							}
					  `
    : props.$isTablet
        ? (0, styled_components_1.css) `
							button {
								svg {
									min-width: 14px;
									min-height: 14px;
								}
								p {
									font-size: 12px;
									min-width: unset;
								}
							}
					  `
        : (0, styled_components_1.css) `
							button {
								svg {
									min-width: 14px;
									min-height: 14px;
								}
								p {
									font-size: 12px;
									min-width: unset;
								}
							}
					  `}
		}
	}

	.img_wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		flex-wrap: wrap;
		width: 100%;

		.img {
			border-radius: 4px;
			flex-shrink: 0;
			width: 100px;
			height: 100px;
			position: relative;
			object-fit: cover;
			background: #000;
		}
	}

	svg {
		min-width: 16px;
		min-height: 16px;
	}

	.empty_file {
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		border-radius: 4px;
		background: var(--color-white, #ffffff);
		padding: 10px;

		color: var(--color-grey-l, #83868a);
		text-align: left;
		font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b5-font-size, 12px);
		line-height: ${props => (props.$isMobile ? '150%' : 'var(--b5-line-height, 22px)')};
		letter-spacing: var(--b5-letter-spacing, -0.02em);
		font-weight: var(--b5-font-weight, 400);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
	}

	.file-button-wrap {
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		${props => ((props.$isSMSRegist || props.$isQnA) && props.$isMobile && `width: 100%;`)}
	}
`;
exports.FileAttach = react_1.default.memo(({ id, className, forceTitle = false, isGmk = false, isOnlyFile = false, isRegist, fileList, isQnA = false, isNotice = false, isContent = false, isSMSRegist = false, setAttachFileList, handlerDownload, uploadButtonText, extraButton, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const fileRef = (0, react_1.useRef)(null);
    //이미지, pdf, 엑셀, 워드, PPT, 텍스트 파일
    const acceptedFileTypes = isSMSRegist ? '.xlsx, .xls' :
        'image/*,application/pdf,.xlsx, .xls, .csv, .ppt, .pptx, .pdf, .doc, .docx, .txt, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain, video/mp4, .mp4, ' +
            // B2: mp3 첨부 — MP3_FEATURE_ENABLED 로 게이트(비활성 시 미허용)
            (featureFlags_1.MP3_FEATURE_ENABLED ? 'audio/mpeg, .mp3, ' : '') +
            '.zip, application/zip, application/x-zip-compressed';
    const onChangeFile = (e) => {
        if (isSMSRegist && fileList.length > 0) {
            alert('엑셀 파일은 하나만 등록 가능합니다.');
            return;
        }
        const files = e.target.files;
        if (files) {
            const newFileList = Array.from(files);
            setAttachFileList &&
                // @ts-ignore
                setAttachFileList(prev => prev ? [...prev, ...newFileList] : [...newFileList]);
        }
        e.target.value = '';
    };
    const handleFileClick = (item) => {
        if (isRegist && setAttachFileList) {
            // @ts-ignore
            setAttachFileList(fileList.filter(file => file !== item));
        }
        if (!isRegist) {
            const a = document.createElement('a');
            a.href = item;
            a.download = item.split('/').pop() || 'download'; // 다운로드 파일명 설정
            document.body.appendChild(a); // a 요소를 문서에 추가
            a.click();
            document.body.removeChild(a); // a 요소를 문서에서 제거
        }
    };
    //드래그 앤 드롭 파일 막기
    const handleDrop = e => {
        e.preventDefault();
        const dt = e.dataTransfer;
        // 드롭된 항목이 폴더인지 파일인지 확인
        for (let i = 0; i < dt.items.length; i++) {
            const item = dt.items[i];
            if (item.kind === 'file') {
                const file = item.getAsFile();
                // 파일 확장자 확인 (예시: mp4, mov 확장자만 허용)
                if (file.type.startsWith('video/') &&
                    (file.type.includes('mp4') || file.type.includes('quicktime'))) {
                    // 파일 처리 로직 추가
                }
                else {
                    alert('폴더를 등록할 수 없습니다.');
                    return;
                }
            }
            else {
                alert('폴더를 등록할 수 없습니다.');
                return;
            }
        }
    };
    const handleDragOver = e => {
        e.preventDefault();
    };
    const renderFileButton = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "file-button-wrap" },
        react_1.default.createElement(element_1.FileInput, { key: id, className: id, ref: fileRef, id: id, onChange: onChangeFile, accept: acceptedFileTypes },
            react_1.default.createElement(element_1.Button, { className: isGmk ? 'btn_default xmd' :
                    className
                        ? className
                        : `btn_tur ${isMobile || (isQnA && isTablet) ? 'mobile-sm' : 'xmd'}`, text: uploadButtonText || t('common.regist'), styles: {
                    buttonWrap: {
                        padding: isSMSRegist ? '10px 2px' : isMobile && isQnA ? '10px' : isGmk ? '12px 26px' : '10px 12px',
                        minHeight: isQnA && isTablet ? '48px' : 'unset',
                        // minWidth: isMobile && isQnA ? '55px' : 'unset',
                        width: isMobile && isQnA ? '100%' : isSMSRegist ? '74px' : 'unset',
                        flex: isMobile ? "1" : "unset"
                    },
                } })),
        isSMSRegist && (react_1.default.createElement(element_1.Button, { className: "btn_line_tur xmd sample-file-download", text: t('sendSMS.sampleFile'), onClick: handlerDownload, styles: {
                buttonWrap: { padding: '10px 2px', width: isMobile ? 'unset' : '74px', flex: isMobile ? "1" : "unset" }
            } })),
        extraButton)), [id, fileRef, onChangeFile, isSMSRegist, fileList, isSMSRegist, handlerDownload, isMobile]);
    const renderImgList = (files) => files.map((file, index) => (react_1.default.createElement(ImageTag_1.default, { key: index, file: typeof file === 'string' ? file : URL.createObjectURL(file) })));
    const renderFileList = (files) => files.map((file, index) => (react_1.default.createElement("div", { key: index, className: "file-item" },
        react_1.default.createElement(element_1.Button, { className: "btn_sliver md_round center body5 cursor attach_item", text: typeof file === 'string' ? file.split('/').pop() : file.name, styles: {
                buttonWrap: {
                    height: 'fit-content',
                    maxWidth: isMobile ? 180 : 220,
                },
            }, option: {
                buttonBeforeIcon: {
                    name: 'file',
                    color: Colors_1.Colors.dark_tur,
                    size: 12,
                    show: true,
                },
                buttonAfterIcon: {
                    name: isRegist ? 'close' : 'file-down',
                    color: Colors_1.Colors.accent,
                    size: 12,
                    show: true,
                },
            }, onClick: () => handleFileClick(file) }))));
    const renderContent = (title, isPicture = false) => (react_1.default.createElement("div", { className: "content-regist-width", style: {
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '10px' : '10px',
            alignItems: isMobile ? 'flex-start' : 'center',
        } },
        (!isSMSRegist && !isOnlyFile && !isGmk) || forceTitle ? (isMobile && isQnA ? (renderFileButton) : (react_1.default.createElement("div", { className: isContent ? 'content-info-filename' : 'task-label', style: {
                minWidth: 70,
            } }, t(title)))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement("div", { className: "fext-field file", style: { overflow: 'hidden', width: '100%' } },
            react_1.default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, className: "file-container", style: isMobile && isSMSRegist ? { flexDirection: 'column', width: '100%' } : {} },
                fileList && fileList.length > 0 ? (react_1.default.createElement("div", { className: isContent ? 'no-file-wrap' : 'file-wrap' },
                    forceTitle && !isPicture
                        ? null
                        : isOnlyFile && (react_1.default.createElement("div", { className: "img_wrap" }, renderImgList(fileList))),
                    forceTitle && isPicture ? null : (react_1.default.createElement("div", { className: "file-item-wrap" }, renderFileList(fileList))))) : isPicture ? (react_1.default.createElement("p", { className: "empty_file" }, t('assignment.noAttachPicturePlaceholer'))) : (react_1.default.createElement("p", { className: isContent ? 'content_empty_file' : 'empty_file', style: isSMSRegist ? { height: '40px', padding: '9px' } : {} }, t('assignment.noAttachFilePlaceholer'))),
                (isGmk || (isRegist && (!isMobile || (isMobile && isNotice)))) && renderFileButton))));
    return (react_1.default.createElement(AttachFileRegistStyled, { className: className, "$isRegist": isRegist, "$isOnlyFile": isOnlyFile, "$forceTitle": forceTitle, "$isMobile": isMobile, "$isTablet": isTablet, "$isSMSRegist": isSMSRegist, "$isQnA": isQnA },
        forceTitle && renderContent('supportRoom.pictuer', true),
        renderContent('assignment.attachFile')));
});
